<template>
    <Card :bordered="false" class="border-radius-0">
        <Tabs
            v-model:activeKey="state.tabKey"
            @update:activeKey="value => $router.push({ name: `company-mgt-tab-6-${value}`, params: $route.params })"
            :centered="true" type="card"
        >
            <TabPane key="1" :tab="$t(`views.company.mgt.tab.request`)"></TabPane>
            <TabPane key="2" :tab="$t(`views.company.mgt.tab.data`)"></TabPane>
        </Tabs>
        <router-view></router-view>
    </Card>
</template>

<script>
import { Card, Tabs } from "ant-design-vue";
import { defineComponent, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { state as stateApp } from "../../../../../app.logic";
import { initState } from "./tab6.logic";

export default defineComponent({
    components: {
        Card,
        Tabs,
        TabPane: Tabs.TabPane
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "company-mgt-tab-6-1" }
    },
    setup(props) {
        const route = useRoute();
        const router = useRouter();
        const companyId = route.params?.companyId;
        const state = reactive(initState({ props, companyId }));
        if (route.name && route.name.startsWith("company-mgt-tab-6-")) {
            state.tabKey = route.name.replace("company-mgt-tab-6-", "").substring(0, 1);
        }
        if (route.name === "company-mgt-tab-6") {
            router.push({ name: `company-mgt-tab-6-${state.tabKey}`, params: route.params });
        }
        return { props, state };
    }
});
</script>
